import PropTypes from 'prop-types';
import {Modal, Button, Row, Col} from 'react-bootstrap';
import dayjs from 'dayjs';
import ReservationPayment from './ReservationPayment';
import {
  RELEASED_COPY,
  RELEASED_UNPAID_COPY,
  isReleased,
  paymentDue,
  payByDeadline,
  statusLabel,
} from '../consultation/bookingState';

export default function ReservationDetailModal({
  show,
  reservation,
  answers,
  complaint,
  refunded,
  onHide,
  cancelReservation,
  onPaid,
  onReleased,
}) {
  const contentStyle = {
    borderRadius: '0.5rem',
    padding: '1rem',
  };

  const released = isReleased(reservation);
  const payBy = reservation ? payByDeadline(reservation) : null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <h3 id="contained-modal-title-vcenter">Reservation Information</h3>
      </Modal.Header>
      <Modal.Body>
        {complaint && dayjs() > dayjs(reservation.reservation_time) && (
          <div style={{...contentStyle}}>
            <h5>Doctor summary</h5>
            <Row>
              <Col>Condition</Col>
              <Col>{complaint.doctor_condition}</Col>
            </Row>
            <Row>
              <Col>Suggestion</Col>
              <Col>{complaint.doctor_summary}</Col>
            </Row>
            <Row>
              <Col>Recommended return visit time</Col>
              <Col>{complaint.doctor_return}</Col>
            </Row>
            <Row>
              <Col xs={12}>Doctor upload images</Col>
              <Col xs={12}>
                {complaint.doctor_images &&
                  complaint.doctor_images.split('||').map((image, index) => (
                    <div key={`image-${index}`}>
                      <img alt="" src={`${image}`} />
                    </div>
                  ))}
              </Col>
            </Row>

            <hr />
          </div>
        )}
        {released && (
          <div style={{...contentStyle}}>
            <h5>{statusLabel(reservation)}</h5>
            <p>{refunded ? RELEASED_COPY.body : RELEASED_UNPAID_COPY}</p>
            <hr />
          </div>
        )}
        {paymentDue(reservation) && (
          <div style={{...contentStyle}}>
            <h5>Payment due</h5>
            <p>This consultation is booked but not paid yet. Complete the payment to keep it.</p>
            {payBy && <p>{`Pay by ${dayjs(payBy).format('YYYY-MM-DD HH:mm')}`}</p>}
            <ReservationPayment
              reservation={reservation}
              onPaid={() => onPaid(reservation.id)}
              onReleased={() => onReleased(reservation.id)}
            />
            <hr />
          </div>
        )}
        <div style={{...contentStyle, backgroundColor: '#EEEEEE'}}>
          <h5>Consultation Info.</h5>
          {answers.map((answer) => {
            return (
              <Row key={`${answer.id}`}>
                <Col>{answer.form_and_questions.question.question_label}</Col>
                <Col>{answer.answer}</Col>
              </Row>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        {reservation &&
          !released &&
          !reservation.is_cancelled &&
          dayjs() < dayjs(reservation.reservation_time) && (
            <Button variant="warning" onClick={() => cancelReservation(reservation.id)}>
              Cancel Reservation
            </Button>
          )}
      </Modal.Footer>
    </Modal>
  );
}

ReservationDetailModal.propTypes = {
  show: PropTypes.bool,
  reservation: PropTypes.object,
  complaint: PropTypes.object,
  answers: PropTypes.array,
  refunded: PropTypes.bool,
  onHide: PropTypes.func,
  cancelReservation: PropTypes.func,
  onPaid: PropTypes.func,
  onReleased: PropTypes.func,
};
